export enum BrowserLocationEvent {
  update = 'update',
  pop = 'pop',
}
